module.exports = __webpack_public_path__ + "img/sneeuwscooter.e01c04d9.jpg";